
{
  "pages": {
    "invoices": "Invoices",
    "subscriptions": "Subscriptions",
    "payouts": "Payouts"
  }
}
